import { render, staticRenderFns } from "./FormElementTitle.vue?vue&type=template&id=1b959fce&scoped=true&"
import script from "./FormElementTitle.vue?vue&type=script&lang=js&"
export * from "./FormElementTitle.vue?vue&type=script&lang=js&"
import style0 from "./FormElementTitle.vue?vue&type=style&index=0&id=1b959fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b959fce",
  null
  
)

export default component.exports